<template>
  <div class="employee-manage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>员工管理</span>
      </template>
      <template v-slot:content>
        <div class="employee-manage-main">
          <div class="add" v-if="maxEmployeeNum>total">
            <el-button
              v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1"
              class="btn-blue"
              @click="goEmployeeAddAccount"
            >新增账号</el-button>
          </div>
          <div class="add" v-else>
            <el-button
              v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1"
              class="btn-blue"
              @click="maxEmployee"
            >新增账号</el-button>
          </div>
          <div class="table">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="department" label="部门"></el-table-column>
              <el-table-column prop="position" label="职位"></el-table-column>
              <el-table-column prop="phone" label="手机"></el-table-column>
              <el-table-column prop="account" label="登录账号"></el-table-column>
              <el-table-column
                prop="state"
                label="是否启用"
                v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1"
              >
                <template slot-scope="scope">
                  <el-switch
                    style="display: block"
                    v-model="scope.row.state"
                    @change="changeStatus(scope.row.id,scope.row.state)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1 || operationList.indexOf(operationsBtns.roleEmployeeAuth) !== -1"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      type="text"
                      class="btn-text"
                      @click="toDepartmentAuthority(scope.row.id)"
                      v-if="operationList.indexOf(operationsBtns.roleEmployeeAuth) !== -1"
                    >权限设置</el-button>
                    <el-button
                      type="text"
                      class="btn-text"
                      @click="goReviseAccount(scope.row.id)"
                      v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1"
                    >编辑</el-button>
                    <el-button
                      type="text"
                      class="btn-text"
                      @click="remove(scope.row.id)"
                      v-if="operationList.indexOf(operationsBtns.roleEmployeeManage) !== -1"
                    >删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="table_pagination">
              <PaginationModul :total="total" :currentPage="page" @queryChange="pageChange"></PaginationModul>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import {
  getDBOperationPermission,
  saveDBModulePermission,
  saveDBOperationPermission,
  saveDBModuleStatusPermission
} from 'common/js/storage'; // 权限数据接口
import DBUser from "models/db/user";
const dbUser = new DBUser();
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationModul from 'base/PaginationTpl';
import DBSiteSet from 'models/db/site-set.js';
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--员工删除/编辑/启用/新增 员工权限设置
      operationsBtns: {
        roleEmployeeManage: 'ROLE_EMPLOYEE_manage',
        roleEmployeeAuth: 'ROLE_EMPLOYEE_auth'
      },
      tableData: [
        // {
        //   name: '虞姬',
        //   department: '技术部',
        //   position: '员工',
        //   phone: 130116478751,
        //   account: 'yuji',
        //   state: true
        // }
      ],
      maxEmployeeNum: 0,
      total: 0, // 条目总数
      page: 1, // 当前页数
      loading: true
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  activated() {
    if (this.$route.params.change) {
      this.getTableData();
      this._getPermission()
    }
  },
  created() {
    this._getPermission()
    this.getTableData();
  },
  methods: {
    // 获取大B用户权限
    _getPermission() {
      dbUser
        .getPermission()
        .then(res => {
          if (res.success) {
            let { authorities, authorityModules, moduleStatus } = res.result;
            saveDBModulePermission(authorityModules);
            saveDBOperationPermission(authorities);
            saveDBModuleStatusPermission(moduleStatus);
            this.operationList = getDBOperationPermission();
          } else {
            console.log("获取权限失败", res.message);
          }
        })
        .catch(e => {
          console.log("获取权限异常");
        });
    },
    // 员工数量限制
    maxEmployee() {
      let num = this.maxEmployeeNum;
      this.$message.error(`员工数量限制：${num}`);
    },
    // 前往添加员工
    goEmployeeAddAccount() {
      this.$router.push('employee-add-account');
    },
    // 获取列表数据
    getTableData() {
      let page = this.page;
      dbSiteSet.getDBEmployee(page).then(res => {
        if (res.success) {
          this.maxEmployeeNum = res.result.employeeNum;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.contact;
            obj.department = value.name;
            obj.phone = value.telephone;
            obj.position = value.position;
            obj.account = value.username;
            obj.state = value.status < 2;
            arr.push(obj);
          });
          this.loading = false;
          this.tableData = arr;
        }
      });
    },
    // 修改账号状态
    changeStatus(id, state) {
      if (state) {
        dbSiteSet.getDBEmployeeUp(id).then(res => {});
      } else {
        dbSiteSet.getDBEmployeeDown(id).then(res => {});
      }
    },
    // 权限设置
    toDepartmentAuthority(id) {
      this.$router.push({
        path: 'employee-authority',
        query: { id: id }
      });
    },
    // 编辑
    goReviseAccount(id) {
      this.$router.push({
        path: 'employee-revise-account',
        query: { id: id }
      });
    },
    // 删除
    remove(id) {
      this.$confirm(`是否确认删除该员工`, '删除员工', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dbSiteSet.getDBEmployeeDelete(id).then(res => {
          if (res.success) {
            this.getTableData();
          }
        });
      });
    },
    // 翻页
    pageChange(data) {
      this.page = data.currentPage;
      this.getDepartment();
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-manage {
  width: 100%;
  height: 100%;
  .employee-manage-main {
    .add {
      margin-bottom: 16px;
      .el-button {
        width: 96px;
        letter-spacing: 4px;
        text-align: center;
        padding: 0;
      }
    }
    .table_pagination {
      height: 56px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .el-pagination {
        height: 28px;
        padding: 0px;
        display: flex;
      }
    }
  }
}
</style>
<style lang="scss">
.employee-manage {
  .employee-manage-main {
    .table {
      .cell {
        .el-button + .el-button {
          margin-left: 24px;
        }
        .el-switch {
          width: 48px;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
